import { IAffiliateCrudModalLang } from '../../../types/lang'

export const affiliateCrudModalLang: IAffiliateCrudModalLang = {
	affiliate_crud_modal: {
		title_edit: 'Edit affiliate_ua',
		title_notes_view: 'View notes for affiliate_ua',
		title_notes_edit: 'Edit notes for affiliate_ua',
		field_name_label: 'Name_ua',
		field_name_placeholder: 'Name_ua',
		field_date_label: 'Date_ua',
		field_date_placeholder: 'Date_ua',
		field_percent_label: 'Percent, %_ua',
		field_percent_placeholder: 'Percent, %_ua',
		field_notes_label: 'Notes_ua',
		field_notes_placeholder: 'Notes_ua',
		btn_add_record: 'Add Record_ua',
		btn_update: 'Save_ua',
		btn_close: 'Close_ua'
	}
}